import { render, staticRenderFns } from "./QueueControlWidget.vue?vue&type=template&id=08586484&scoped=true&"
import script from "./QueueControlWidget.vue?vue&type=script&lang=ts&"
export * from "./QueueControlWidget.vue?vue&type=script&lang=ts&"
import style0 from "./QueueControlWidget.vue?vue&type=style&index=0&id=08586484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08586484",
  null
  
)

export default component.exports